import React from 'react';
import { storyData } from '../data/mock';

const StorySection = () => {
  return (
    <section className="bg-[#F8F8F8] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-4xl mx-auto">
        {/* Intro - Tighter spacing */}
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#191919] mb-4 tracking-tight leading-tight animate-fade-in-up">
            {storyData.intro}
          </h2>
          <p className="text-2xl md:text-3xl lg:text-4xl text-[#FF6699] font-bold animate-fade-in-up delay-200">
            {storyData.highlight}
          </p>
        </div>

        {/* Story Title - Dramatic Black Card with "Pagi" and "Merah" in Pink - Stacked Layout */}
        <div className="bg-[#191919] rounded-2xl p-10 md:p-14 mb-10 transform hover:scale-[1.02] transition-transform duration-300 shadow-2xl">
          <h3 className="text-3xl md:text-5xl lg:text-6xl font-black text-[#F8F8F8] text-center tracking-tight leading-tight flex flex-col gap-2">
            <span>3:47 <span className="text-[#FF6699]">Pagi</span>.</span>
            <span>Mata <span className="text-[#FF6699]">Merah</span>.</span>
            <span>Akaun <span className="text-[#FF6699]">Merah</span>.</span>
          </h3>
        </div>

        {/* Story Content - Dramatic Storytelling - Tighter spacing */}
        <div className="space-y-5 text-center">
          {/* Opening */}
          <p className="text-2xl md:text-3xl text-[#191919] font-bold animate-fade-in-up">
            {storyData.content[0]}
          </p>
          
          {/* The Dramatic Moment */}
          <div className="py-4 space-y-3">
            <div className="flex justify-center">
              <div className="w-1 h-12 bg-[#FF6699]" />
            </div>
            <p className="text-xl md:text-2xl text-[#191919]/70 font-medium">
              {storyData.content[1]}
            </p>
            <p className="text-2xl md:text-3xl text-[#FF6699] font-bold py-3 bg-[#FF6699]/10 rounded-xl mx-auto max-w-2xl">
              {storyData.content[2]}
            </p>
          </div>

          {/* The Silence */}
          <div className="py-6 space-y-4">
            <div className="flex justify-center gap-4">
              <div className="w-3 h-3 bg-[#191919]/20 rounded-full" />
              <div className="w-3 h-3 bg-[#191919]/20 rounded-full" />
              <div className="w-3 h-3 bg-[#191919]/20 rounded-full" />
            </div>
            
            <div className="space-y-2 text-xl md:text-2xl text-[#191919]/60">
              <p className="animate-fade-in" style={{ animationDelay: '0.1s' }}>
                {storyData.content[3]}
              </p>
              <p className="animate-fade-in" style={{ animationDelay: '0.2s' }}>
                {storyData.content[4]}
              </p>
              <p className="animate-fade-in" style={{ animationDelay: '0.3s' }}>
                {storyData.content[5]}
              </p>
            </div>
          </div>

          {/* The Question - Big Dramatic Box */}
          <div className="bg-[#191919] rounded-2xl p-6 md:p-10 my-8 shadow-xl">
            <p className="text-xl md:text-2xl lg:text-3xl text-[#F8F8F8] font-bold leading-relaxed">
              {storyData.content[6]}
            </p>
          </div>

          {/* The Pattern */}
          <div className="py-4">
            <p className="text-lg md:text-xl text-[#191919]/70">
              {storyData.content[7]}
            </p>
          </div>

          {/* The Resilience - Pink Box, White Text, Straight */}
          <div className="py-4">
            <div className="inline-block bg-[#FF6699] px-8 py-6 rounded-2xl">
              <p className="text-2xl md:text-4xl text-[#F8F8F8] font-black tracking-tight">
                {storyData.content[8]}
              </p>
            </div>
          </div>

          {/* Simple Horizontal Pink Line Divider */}
          <div className="flex justify-center py-4">
            <div className="w-32 h-1 bg-[#FF6699]" />
          </div>

          {/* The Hope */}
          <div className="space-y-4 pt-2 pb-4">
            <p className="text-xl md:text-2xl text-[#191919] font-medium">
              {storyData.content[9]}
            </p>
            {/* Pink color */}
            <p className="text-2xl md:text-3xl text-[#FF6699] font-bold">
              {storyData.content[10]}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
